import { render, staticRenderFns } from "./ActionHints.vue?vue&type=template&id=5faee005&scoped=true&"
import script from "./ActionHints.vue?vue&type=script&lang=js&"
export * from "./ActionHints.vue?vue&type=script&lang=js&"
import style0 from "./ActionHints.vue?vue&type=style&index=0&id=5faee005&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faee005",
  null
  
)

export default component.exports